module.exports = __webpack_public_path__ + "static/python-bd45cfa6e6704e1c3145b194ab3048f1.png";